import React from "react";
import PropTypes from "prop-types";
import Text from '@gc-npm/components.text'
import DeviceCarousel from "./device-carousel";
// import BenefitsInfo from "./benefits-info";
import style from "./style";

const DevicesSection = (props) => {
  const benefits = Object.keys(props["Information-Card"])
    .filter((key) => key.startsWith("Item-"))
    .map((key) => props["Information-Card"][key]);

  const carouselContent = Object.keys(props["Carrusel"])
    .filter((key) => key.startsWith("Slide-"))
    .map((key) => props["Carrusel"][key]);

  const taggingInfo = props.taggingInfo;

  const mainTittle = (props && props['mainTitle']) || null;

  return (
    <>
      <section className="devices-section container" data-cy="DeviceSection Container">
        <div className="content-container">
          <div className="row">
            <div className="col-xs-12">
              {mainTittle && (<Text {...mainTittle} />) }
            </div>
          </div>
          <div className="row">
            <DeviceCarousel
              content={carouselContent}
              taggingInfo={taggingInfo}
            />
          </div>
        </div>
      </section>
      <style jsx>{style}</style>
    </>
  );
};

export default DevicesSection;

DevicesSection.propTypes = {};

DevicesSection.defaultProps = {};
